/* ==========================================================================
   #SEGMENT REDEMPTION
========================================================================== */

/**
 * Huggg segments
 * 1. We have reversed the confirmation / cancel actions here. When the "cancel"
 *    action is pressed, we instead enact the confirmation method. This is to
 *    make the user think more about what they're doing instead of just blindly
 *    hitting the big red button without reading the important text.
 * 2. @improvement I was messing with the FormDialog and so I moved it to state,
 *    rather than refs. Can we do the same with the confirm dialog next time we
 *    change it?
 * 3. Technically legacy now. We used to show the confirm dialog first for forms
 *    but now we go straight to the form modal and bypass it.so you _should_ only
 *    get here for non-form types. Leaving the `if` here anyway in case of state
 *    mismatch or silly mistakes.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';

import { Pin4, PrepaidCardRedemption } from 'components/ui';
import { Form, PrimaryButton } from '@huggg/react-components';
import styles from './segments.module.scss';
const SegmentRedemption = props => {
  const {
    huggg,
    onConfirm,
    selectedSegment,
    isFormRedemptionType,
    isPin4Type,
    isPrepaidCardType,
    defaultTerritory
  } = props;

  const getFormTerritory = formData => formData?.address?.countryIso;

  const onFormConfirmClick = formData => {
    const territory = getFormTerritory(formData) ?? defaultTerritory;
    onConfirm(selectedSegment, { territory, formData });
  };

  const onPin4ConfirmClick = formData => {
    const territory = getFormTerritory(formData) ?? defaultTerritory;
    onConfirm(selectedSegment, { territory, formData });
  };

  const onPrepaidConfirmClick = formData => {
    const territory = getFormTerritory(formData) ?? defaultTerritory;
    onConfirm(selectedSegment, { territory, ...formData });
  };

  // we only show the pin4 image and product description when there is
  // no product card on the page. (e.g. when the segment is standalone)
  const pin4ProductDetails = () =>
    selectedSegment?.images && selectedSegment?.images.length
      ? {
          imageUrls: selectedSegment?.images,
          title: selectedSegment?.name,
          description: path(['purchase', 'recipient_description'], huggg)
        }
      : null;

  if (isPrepaidCardType) {
    return (
      <PrepaidCardRedemption
        data-test-id="prepaid-card-redemption-screen"
        onConfirm={onPrepaidConfirmClick}
      />
    );
  }

  if (isPin4Type) {
    return (
      <Pin4
        data-test-id="pin4-redemption-screen"
        onComplete={onPin4ConfirmClick}
        productDetails={pin4ProductDetails()}
      />
    );
  }

  if (isFormRedemptionType) {
    return (
      <Form
        data-test-id="form-redemption-screen"
        model={selectedSegment?.configuration}
        onConfirm={onFormConfirmClick}
        outOfStock={selectedSegment?.configuration?.outOfStock}
      />
    );
  }

  return (
    <div data-test-id="retry-redeem-button" className={styles.buttonContainer}>
      <PrimaryButton
        onClick={() =>
          onConfirm(selectedSegment, { territory: defaultTerritory })
        }
        label="RETRY"
      />
    </div>
  );
};

SegmentRedemption.propTypes = {
  huggg: PropTypes.object.isRequired,
  selectedSegment: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default SegmentRedemption;
